import React, { Component } from 'react';
class getContacto extends Component {
 render () {

   console.log(this.props.telefono+". "+this.props.leyenda_contacto+". "+this.props.activo)
   let titulo
   let img
   let leyenda
   let sms
   if(Number(this.props.activo)===-1){
     titulo = "Local Cerrado"
     img=<img className="cssversion_pxh200" alt="Cargando Imagen . . ." src={ require('../image/pngwing.com.png') }  />
     leyenda="Lo sentimos, nuestro local se encuentra cerrado."
     sms=this.props.sms
   }
   if(Number(this.props.activo)===-2){
     titulo = "Fuera de Rango"
     img=<img className="cssversion_pxh200" alt="Cargando Imagen . . ." src={ require('../image/lejos.png') }  />
     leyenda="Lo sentimos, pero está fuera de nuestro rango."
     sms="Usted está "+ this.props.sms + "Km lejos de nosotros"
   }

   return (

     <div className="cssversion_menu cssversion_colorblanco">
       <div className="cssversion_pw100 cssversion_pxh50" style={{"display":"flex"}}  onClick={ () => this.props.get_go_to('')}>
         <div className="cssversion_pw15 cssversion_pxh50 cssversion_contentCenter">
           <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') }  />
         </div>
         <div className="cssversion_pw85 cssversion_pxh50 cssversion_contentCenter">
           <span className="span-global-link" >{titulo}</span>
         </div>
       </div>
       <div className="cssversion_pw90 cssversion_contentCenter" style={{"padding":"10px","textAlign":"center"}}>
        <span className="span-global" >{leyenda}</span>
       </div>
       <div className="cssversion_pw90 cssversion_contentCenter" style={{"padding":"10px","textAlign":"center"}}>
        <span className="span-global-link" style={{"fontSize":"18pt"}}>{sms}</span>
       </div>
       <div className="cssversion_pw90 cssversion_contentCenter" style={{"padding":"10px","textAlign":"center"}}>
        {img}
       </div>
       <div className="cssversion_pw90 cssversion_contentCenter" style={{"padding":"10px","textAlign":"center"}}>
          <span className="span-global-link" >Para más Información no dude en contactarnos al {this.props.telefono}</span>
       </div>
    </div>

   )
   /*<div className="modal-dialog-datos">
     <div className="modal-content-datos">
       <div className="grid-container-menu_list_ficha">
         <div className="div_menu_1_list_ficha">
           <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to('')} />
         </div>
         <div className="lbl_menu_2_list_ficha">
           <span className="span-global-link">Fuera de Rango</span>
         </div>
       </div>
       <div>
       <br/>
       <br/>
        Su ubicación se encuentra fuera del Rango
        <br/>
        {this.props.leyenda_contacto}
        <br/>
        {this.props.telefono}
       </div>
     </div>
   </div>*/
 }
}
export default getContacto;
